import { module } from 'stereomodularjs';
import svgIco from '../components/svgIco.vue'
import ColorSelector from '../components/ColorSelector.vue'
import { createApp } from "vue/dist/vue.esm-bundler.js"

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;
        const data = { spriteURL: this.el.dataset.sprite }

        const app = createApp({
            template: '<ColorSelector />',
            components: { svgIco, ColorSelector },
            data() {
                return data;
            },
            methods: {

            },
            computed: {


            },
            watch: {

            },
            mounted() { },
        })
        app.config.globalProperties.cash = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
        }
        app.config.globalProperties.cents = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' $';
        }
        app.config.globalProperties.pct = (val) => {
            return parseFloat(val).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace('.', ',') + ' %';
        }
        app.config.globalProperties.nb = (value) => {
            return Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        }
        app.component("svgIco", svgIco)

        app.mount(self.el)
    }
}
